module.exports = __webpack_public_path__ + "media/images/etiqa-card-b0fd53d1b4a802fa763dc6c37803b78a.png";